module.exports = __webpack_public_path__ + "img/img-archive-bg01.71bc072a.png";